'use client';

// FindLeadsButton — one-click bridge to the bundled lead-scraper app.
// Clicking it asks the main app to start the scraper (port 3100) if it isn't
// already running, then opens its login page. No terminal, no starter file.

import { useState } from 'react';
import { launchLeadScraper } from '@/lib/lead_scraper_client';

export default function FindLeadsButton({ style = {}, label = '🎯 Find Leads' }) {
    const [busy, setBusy] = useState(false);

    const launch = async () => {
        setBusy(true);
        try { await launchLeadScraper(); }
        finally { setBusy(false); }
    };

    return (
        <button
            onClick={launch}
            disabled={busy}
            title="Open the lead scraper to find & download new leads"
            style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                padding: '10px 20px', borderRadius: 999, fontSize: '14px', fontWeight: 700,
                border: '1px solid var(--ink)', cursor: busy ? 'wait' : 'pointer',
                background: 'var(--ink)', color: 'var(--paper)',
                boxShadow: 'none', opacity: busy ? 0.7 : 1, fontFamily: 'var(--font-body)',
                ...style,
            }}
        >
            {busy ? 'Starting…' : label} {!busy && <span aria-hidden="true">↗</span>}
        </button>
    );
}
